module.exports = "/_next/static/images/Hero-lg-b2d94a612faae085145e25da11898f61.webp";